// extracted by mini-css-extract-plugin
module.exports = {"modalFoot":"modal-foot_component_modalFoot__o3k0L"};